import { render, staticRenderFns } from "./redirect-auto-auth.vue?vue&type=template&id=0a594b5c&scoped=true"
import script from "./redirect-auto-auth.vue?vue&type=script&lang=js"
export * from "./redirect-auto-auth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a594b5c",
  null
  
)

export default component.exports